import * as angular from "angular";

export class CircleMarkersService {
  clearAll(markers) {
    markers.forEach((marker) => {
      marker.setMap(null);
    });
  }

  createCircle(map, circle) {
    return new google.maps.Circle({
      strokeColor: '#278BFF',
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: '#27C4FF',
      fillOpacity: 0.06,
      map: map,
      center: circle.center,
      radius: circle.radius
    });
  }
}

angular
  .module('bringoz.admin.map')
  .service('circleMarkersService', CircleMarkersService);
